import React, { useState } from "react";
import "./feature.css";
import liIcon from "../../assets/li-icon.svg";
import tabImage1 from "../../assets/FeatureSection/Financial Services.svg";
import tabImage2 from "../../assets/FeatureSection/Healthcare.svg";
import tabImage3 from "../../assets/FeatureSection/Retail & E-Commerce.svg";
import tabImage4 from "../../assets/FeatureSection/Manufacturing & Supply Chain.svg";
import tabImage5 from "../../assets/FeatureSection/Government & Public Sector.svg";
import useIntersectionObserver from "../customHooks/useIntersectionObserver";
import FinancialServices from "../../assets/FeatureSection/FinancialServices";
import Healthcare from "../../assets/FeatureSection/Healthcare";
import Retail from "../../assets/FeatureSection/Retail";
import Manufacturing from "../../assets/FeatureSection/Manufacturing";
import Government from "../../assets/FeatureSection/Government";

export default function Feature() {
  const [ref, isVisible] = useIntersectionObserver({ threshold: 0.1 });
  const [activeTab, setActiveTab] = useState(0);
  const handleTabSwitch = (index) => {
    setActiveTab(index);
  };
  const tabLinks = [
    {
      category: "Financial Services",
      heading: "Streamline Financial Operations with AI",
      points: [
        {
          heading: "Automated Data Entry & Reconciliation",
          paragraph:
            "Extracts, inputs, and verifies financial data across platforms.",
        },
        {
          heading: "Regulatory Compliance Reporting",
          paragraph:
            "Automates report generation and submission to regulatory bodies.",
        },
        {
          heading: "Customer Onboarding & KYC Processing",
          paragraph: "Extracts details from forms and updates CRM systems.",
        },
        {
          heading: "Fraud Detection & Transaction Monitoring",
          paragraph: "Analyzes transaction patterns and flags anomalies.",
        },
      ],
      image: tabImage1,
      icon: (fill) => <FinancialServices fill={fill.fill} />,
    },
    {
      category: "Healthcare & Life Sciences",
      heading: "Enhance Patient Care with AI Automation",
      points: [
        {
          heading: "Electronic Health Record (EHR) Management",
          paragraph: "Automates data entry and retrieval from EHR systems.",
        },
        {
          heading: "Medical Billing & Claims Processing",
          paragraph: "Extracts and submits insurance claims efficiently.",
        },
        {
          heading: "Clinical Data Analysis & Reporting",
          paragraph: "Gathers and processes patient data for insights.",
        },
        {
          heading: "Lab Test & Prescription Automation",
          paragraph: "Assists in order processing and prescription validation.",
        },
      ],
      image: tabImage2,
      icon: (fill) => <Healthcare fill={fill.fill} />,
    },
    {
      category: "Retail & E-Commerce",
      heading: "Boost Sales and Efficiency with AI",
      points: [
        {
          heading: "Inventory Management & Stock Updates",
          paragraph: "Monitors stock levels and updates records automatically.",
        },
        {
          heading: "Customer Support Ticket Automation",
          paragraph: "Automates response generation and case assignment.",
        },
        {
          heading: "Pricing & Competitor Analysis",
          paragraph:
            "Scrapes competitor pricing data for strategy adjustments.",
        },
        {
          heading: "Order Processing & Fulfillment",
          paragraph: "Automates invoice creation and shipment tracking.",
        },
      ],
      image: tabImage3,
      icon: (fill) => <Retail fill={fill.fill} />,
    },
    {
      category: "Manufacturing & Supply Chain",
      heading: "Optimize Production and Logistics",
      points: [
        {
          heading: "Production Scheduling & Monitoring",
          paragraph: "Automates work order management and tracking.",
        },
        {
          heading: "Supply Chain Optimization",
          paragraph: "Streamlines procurement and logistics data handling.",
        },
        {
          heading: "Quality Control & Compliance Audits",
          paragraph: "Conducts automated inspections and compliance checks.",
        },
        {
          heading: "Vendor Management & Contract Processing",
          paragraph: "Automates contract verification and renewals.",
        },
      ],
      image: tabImage4,
      icon: (fill) => <Manufacturing fill={fill.fill} />,
    },
    {
      category: "Government & Public Sector",
      heading: "Transform Public Services with AI",
      points: [
        {
          heading: "Citizen Services Automation",
          paragraph:
            "Processes applications for permits, licenses, and benefits.",
        },
        {
          heading: "Tax Filing & Compliance Audits",
          paragraph: "Automates tax form validation and submission.",
        },
        {
          heading: "Law Enforcement & Case Management",
          paragraph: "Organizes digital case files and legal documents.",
        },
        {
          heading: "E-Governance & Public Data Processing",
          paragraph:
            "Handles citizen inquiries and automates government reports.",
        },
      ],
      image: tabImage5,
      icon: (fill) => <Government fill={fill.fill} />,
    },
  ];

  return (
    <section
      className={`features-section ${isVisible ? "section-animation" : ""}`}
      ref={ref}
      id="four"
    >
      <div className="container">
        <div className="section-heading">
          <div className="heading-tag">
            <span>Features</span>
          </div>
          <div className="heading-description">
            <h2>Industry-Specific Applications of AI Aviator</h2>
            <p>Revolutionizing Workflows with AI-Powered GUI Automation</p>
          </div>
        </div>
        <div className="tab-switch-wrapper">
          <div className="tab-links-wrapper">
            {tabLinks.map((item, index) => (
              <div
                className={`${activeTab === index ? "active" : ""}`}
                onClick={() => handleTabSwitch(index)}
                key={index}
              >
                <item.icon
                  fill={`${activeTab === index ? "#000000" : "#00000085"}`}
                />
                <p>{item.category}</p>
              </div>
            ))}
          </div>
          <div className="tab-switch-body">
            {tabLinks.map((item, index) => (
              <div
                className={`tab-switch-content ${
                  activeTab === index ? "active" : ""
                } `}
                key={index}
              >
                <div className="tab-switch-content-left">
                  <h3>{item.heading}</h3>
                  <div className="tab-pointers">
                    <ul>
                      {item.points.map((item, index) => (
                        <li key={index}>
                          <img src={liIcon} alt="tab-point-icon" />
                          <div>
                            <h4>{item.heading}</h4>
                            <p>{item.paragraph}</p>
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
                <div className="tab-switch-content-right">
                  <img src={item.image} alt="tab-switch-image" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
